var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBikeMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91687 1.72852H6.96436V7.55379H7.91687V1.72852Z",
    fill: "#201F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4417 6.15409C8.29645 6.15409 8.98936 5.476 8.98936 4.63954C8.98936 3.80308 8.29645 3.125 7.4417 3.125C6.58695 3.125 5.89404 3.80308 5.89404 4.63954C5.89404 5.476 6.58695 6.15409 7.4417 6.15409Z",
    fill: "#303261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44161 5.77592C8.08273 5.77592 8.60246 5.26731 8.60246 4.63991C8.60246 4.01251 8.08273 3.50391 7.44161 3.50391C6.80049 3.50391 6.28076 4.01251 6.28076 4.63991C6.28076 5.26731 6.80049 5.77592 7.44161 5.77592Z",
    fill: "#E9D844"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65119 2.19536H6.15296L4.96242 1.18594H0.45752V0.253906H5.3177L6.50824 1.26333H8.2959L9.48639 0.253906H14.4261V1.18594H9.84172L8.65119 2.19536Z",
    fill: "#303261"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66427 17.224H8.71187V9.06869C8.71187 8.34053 8.10663 7.74844 7.36276 7.74844C6.61868 7.74844 6.01344 8.34053 6.01344 9.06869V17.224H5.06104V9.06869C5.06104 7.82675 6.09367 6.81641 7.36276 6.81641C8.63185 6.81641 9.66427 7.8267 9.66427 9.06869V17.224Z",
    fill: "#B91618"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62964 0H0V1.45632H3.62964V0Z",
    fill: "#B91618"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 0H11.3701V1.45632H14.9998V0Z",
    fill: "#B91618"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60028 24.0002H7.12465C6.83683 24.0002 6.60352 23.7719 6.60352 23.4902V9.88889C6.60352 9.60722 6.83683 9.37891 7.12465 9.37891H7.60028C7.88811 9.37891 8.12142 9.60722 8.12142 9.88889V23.4902C8.12142 23.7719 7.88811 24.0002 7.60028 24.0002Z",
    fill: "#201F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60242 16.3105H6.01221V16.6306H6.60242V16.3105Z",
    fill: "#F16D5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05838 16.3105H3.9917V16.6306H5.05838V16.3105Z",
    fill: "#F16D5C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72196 19.9316H3.65527V20.2516H4.72196V19.9316Z",
    fill: "#F16D5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71082 16.3105H8.12061V16.6306H8.71082V16.3105Z",
    fill: "#F16D5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7288 16.3105H9.66211V16.6306H10.7288V16.3105Z",
    fill: "#F16D5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4627 12.7578H10.396V13.0778H11.4627V12.7578Z",
    fill: "#F16D5C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74353 16.0566H4.18799V20.2519H4.74353V16.0566Z",
    fill: "#303261"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.473 12.7578H9.91748V16.953H10.473V12.7578Z",
    fill: "#303261"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98934 19.3555H2.20361V20.8313H3.98934V19.3555Z",
    fill: "#201F3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5152 12.1797H10.7295V13.6555H12.5152V12.1797Z",
    fill: "#201F3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7513 7.5H29.248C30.4599 7.5 31.4485 8.85 31.4485 10.5048V19.65C31.4485 20.3903 31.002 21 30.4599 21H23.5394C22.9973 21 22.5508 20.3903 22.5508 19.65V10.5048C22.5508 8.85 23.5394 7.5 24.7513 7.5Z",
    fill: "#B91618"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 16.5508C28.145 16.5508 29.045 17.4611 29.045 18.6197V21.9301C29.045 23.0887 28.145 23.9991 26.9996 23.9991C25.8541 23.9991 24.9541 23.0887 24.9541 21.9301V18.6197C24.9541 17.4611 25.8541 16.5508 26.9996 16.5508Z",
    fill: "#201F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 13.6543C28.7998 13.6543 30.2725 15.144 30.2725 16.9646V18.6198H23.7271V16.9646C23.7271 15.144 25.1998 13.6543 26.9998 13.6543Z",
    fill: "#F16D5C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1816 11.5859H27.818V12.4135H26.1816V11.5859Z",
    fill: "#201F3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1816 9.93164H27.818V10.7592H26.1816V9.93164Z",
    fill: "#201F3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1138 4.13867H35.182V4.96626H32.1138V4.13867Z",
    fill: "#303261"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8179 4.13867H21.8451V4.96626H18.8179V4.13867Z",
    fill: "#303261"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.909 4.01443H31.0908V1.65581C31.0908 1.49029 31.1726 1.32477 31.3363 1.28339L33.6272 0.373047L33.9545 1.11787L31.909 1.94546V4.01443Z",
    fill: "#201F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5454 0H36V1.65517H33.5454V0Z",
    fill: "#201F3F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9091 4.13697H22.091V1.94387L20.0864 1.11628L20.3728 0.330078L22.6228 1.24042C22.8273 1.32318 22.9091 1.4887 22.9091 1.65422V4.13697Z",
    fill: "#201F3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H20.4545V1.65517H18V0Z",
    fill: "#201F3F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.318 5.37979L28.2271 6.20738H25.7725L21.6816 5.37979V3.72461H32.318V5.37979Z",
    fill: "#B91618"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.862C28.3556 7.862 29.4545 6.75043 29.4545 5.37924C29.4545 4.00805 28.3556 2.89648 27 2.89648C25.6443 2.89648 24.5454 4.00805 24.5454 5.37924C24.5454 6.75043 25.6443 7.862 27 7.862Z",
    fill: "#303261"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 7.03495C27.9034 7.03495 28.636 6.29391 28.636 5.37978C28.636 4.46566 27.9034 3.72461 26.9996 3.72461C26.0959 3.72461 25.3633 4.46566 25.3633 5.37978C25.3633 6.29391 26.0959 7.03495 26.9996 7.03495Z",
    fill: "#E9D844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeMotor);
export default __webpack_public_path__ + "static/media/bikeMotor.6ff4d1e40fbd2a5510123ac68b1fa274.svg";
export { ForwardRef as ReactComponent };